import { defineMessages } from "@/i18n";
import en from "./en";

export const libErrorsMessages = defineMessages("lib-errors", en);
